function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconClearSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.917 11.993l-1.945-1.944 1.945-1.945-.973-.972L10 9.077 8.055 7.132l-.972.972 1.945 1.945-1.945 1.944.972.973L10 11.02l1.944 1.945.973-.973z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 15.5a5.5 5.5 0 100-11 5.5 5.5 0 000 11zm0 1.375a6.875 6.875 0 100-13.75 6.875 6.875 0 000 13.75z",
    fill: props.color
  }));
}

export default SvgIconClearSmall;